import { Form } from '@tribeplatform/react-sdk/components'
import { Alert } from '@tribeplatform/react-ui-kit/Alert'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Link } from '@tribeplatform/react-ui-kit/Link'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

import { AppSettingsProps } from '../types'

const GTM_CONTAINER_ID_REGEX = /^(GTM-[A-Z0-9]+)$/
export const GoogleTagManagerSettings = ({
  app,
  appSettings,
  updateSettings,
  isUpdating,
}: AppSettingsProps) => {
  return (
    <Card>
      <Card.Content>
        <Form
          defaultValues={appSettings}
          onSubmit={data => {
            updateSettings({
              appId: app?.id,
              settings: JSON.stringify({ containerId: data?.containerId }),
            })
              .then(() => {
                toast({
                  title: 'Settings successfully updated',
                  status: 'success',
                })
              })
              .catch(() => {
                toast({
                  title: 'Error updating settings',
                  status: 'error',
                })
              })
          }}
          className="flex flex-col gap-3"
        >
          <h3>Container ID</h3>
          {appSettings && !appSettings?.containerId && (
            <Alert
              status="warning"
              title="You need to update your container ID to receive data in Google Tag Manager"
            />
          )}
          <Form.Input
            name="containerId"
            label="Google Tag Manager Container ID"
            placeholder="i.e. GTM-XXXXXXX"
            validation={{
              pattern: {
                value: GTM_CONTAINER_ID_REGEX,
                message: 'Invalid Container ID Format',
              },
            }}
          />
          <p>
            Don&apos;t know how to get Container ID?{' '}
            <Link
              href="https://support.google.com/tagmanager/answer/6103696?hl=en"
              external
            >
              Click here for instructions
            </Link>
          </p>
          <Form.Actions>
            <Button type="submit" variant="primary" loading={isUpdating}>
              Save settings
            </Button>
          </Form.Actions>
        </Form>
      </Card.Content>
    </Card>
  )
}
